(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 6380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Masonry_Masonry; }
});

// UNUSED EXPORTS: getStyle, parseToNumber

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.8/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(9028);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.8/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2182);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+utils@5.8.0_react@18.1.0/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(9198);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(1093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(6237);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.8.2_af7df85dba8b323697c79827b138cac7/node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(9938);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.8.2_af7df85dba8b323697c79827b138cac7/node_modules/@mui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(6111);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+utils@5.8.0_react@18.1.0/node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(7875);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+utils@5.8.0_react@18.1.0/node_modules/@mui/utils/esm/useForkRef.js + 1 modules
var useForkRef = __webpack_require__(362);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(1626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(3236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+utils@5.8.0_react@18.1.0/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(9771);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+utils@5.8.0_react@18.1.0/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(8184);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mui+lab@5.0.0-alpha.84_364cb472411fb39ddef23ac98c954f90/node_modules/@mui/lab/Masonry/masonryClasses.js

function getMasonryUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiMasonry', slot);
}
const masonryClasses = (0,generateUtilityClasses/* default */.Z)('MuiMasonry', ['root']);
/* harmony default export */ var Masonry_masonryClasses = ((/* unused pure expression or super */ null && (masonryClasses)));
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2086);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mui+lab@5.0.0-alpha.84_364cb472411fb39ddef23ac98c954f90/node_modules/@mui/lab/Masonry/Masonry.js


const _excluded = ["children", "className", "component", "columns", "spacing", "defaultColumns", "defaultHeight", "defaultSpacing"];










const parseToNumber = val => {
  return Number(val.replace('px', ''));
};
const lineBreakStyle = {
  flexBasis: '100%',
  width: 0,
  margin: 0,
  padding: 0
};

const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getMasonryUtilityClass, classes);
};

const getStyle = ({
  ownerState,
  theme
}) => {
  let styles = {
    width: '100%',
    display: 'flex',
    flexFlow: 'column wrap',
    alignContent: 'flex-start',
    boxSizing: 'border-box',
    '& > *': {
      boxSizing: 'border-box'
    }
  };
  const stylesSSR = {}; // Only applicable for Server-Side Rendering

  if (ownerState.isSSR) {
    const orderStyleSSR = {};
    const defaultSpacing = Number(theme.spacing(ownerState.defaultSpacing).replace('px', ''));

    for (let i = 1; i <= ownerState.defaultColumns; i += 1) {
      orderStyleSSR[`&:nth-of-type(${ownerState.defaultColumns}n+${i % ownerState.defaultColumns})`] = {
        order: i
      };
    }

    stylesSSR.height = ownerState.defaultHeight;
    stylesSSR.margin = -(defaultSpacing / 2);
    stylesSSR['& > *'] = (0,esm_extends/* default */.Z)({}, styles['& > *'], orderStyleSSR, {
      margin: defaultSpacing / 2,
      width: `calc(${(100 / ownerState.defaultColumns).toFixed(2)}% - ${defaultSpacing}px)`
    });
    return (0,esm_extends/* default */.Z)({}, styles, stylesSSR);
  }

  const spacingValues = (0,breakpoints/* resolveBreakpointValues */.P$)({
    values: ownerState.spacing,
    breakpoints: theme.breakpoints.values
  });
  const transformer = (0,esm_spacing/* createUnarySpacing */.hB)(theme);

  const spacingStyleFromPropValue = propValue => {
    const themeSpacingValue = Number(propValue);
    const spacing = Number((0,esm_spacing/* getValue */.NA)(transformer, themeSpacingValue).replace('px', ''));
    return (0,esm_extends/* default */.Z)({
      margin: -(spacing / 2),
      '& > *': {
        margin: spacing / 2
      }
    }, ownerState.maxColumnHeight && {
      height: Math.ceil(ownerState.maxColumnHeight + spacing)
    });
  };

  styles = (0,deepmerge/* default */.Z)(styles, (0,breakpoints/* handleBreakpoints */.k9)({
    theme
  }, spacingValues, spacingStyleFromPropValue));
  const columnValues = (0,breakpoints/* resolveBreakpointValues */.P$)({
    values: ownerState.columns,
    breakpoints: theme.breakpoints.values
  });

  const columnStyleFromPropValue = propValue => {
    const columnValue = Number(propValue);
    const width = `${(100 / columnValue).toFixed(2)}%`;
    const spacing = typeof spacingValues !== 'object' ? (0,esm_spacing/* getValue */.NA)(transformer, Number(spacingValues)) : '0px';
    return {
      '& > *': {
        width: `calc(${width} - ${spacing})`
      }
    };
  };

  styles = (0,deepmerge/* default */.Z)(styles, (0,breakpoints/* handleBreakpoints */.k9)({
    theme
  }, columnValues, columnStyleFromPropValue)); // configure width for responsive spacing values

  if (typeof spacingValues === 'object') {
    styles = (0,deepmerge/* default */.Z)(styles, (0,breakpoints/* handleBreakpoints */.k9)({
      theme
    }, spacingValues, (propValue, breakpoint) => {
      if (breakpoint) {
        const themeSpacingValue = Number(propValue);
        const lastBreakpoint = Object.keys(columnValues).pop();
        const spacing = (0,esm_spacing/* getValue */.NA)(transformer, themeSpacingValue);
        const column = typeof columnValues === 'object' ? columnValues[breakpoint] || columnValues[lastBreakpoint] : columnValues;
        const width = `${(100 / column).toFixed(2)}%`;
        return {
          '& > *': {
            width: `calc(${width} - ${spacing})`
          }
        };
      }

      return null;
    }));
  }

  return styles;
};
const MasonryRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiMasonry',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [styles.root];
  }
})(getStyle);
const Masonry = /*#__PURE__*/react.forwardRef(function Masonry(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiMasonry'
  });

  const {
    children,
    className,
    component = 'div',
    columns = 4,
    spacing = 1,
    defaultColumns,
    defaultHeight,
    defaultSpacing
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const masonryRef = react.useRef();
  const [maxColumnHeight, setMaxColumnHeight] = react.useState();
  const isSSR = !maxColumnHeight && defaultHeight && defaultColumns !== undefined && defaultSpacing !== undefined;
  const [numberOfLineBreaks, setNumberOfLineBreaks] = react.useState(isSSR ? defaultColumns - 1 : 0);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    spacing,
    columns,
    maxColumnHeight,
    defaultColumns,
    defaultHeight,
    defaultSpacing,
    isSSR
  });

  const classes = useUtilityClasses(ownerState);

  const handleResize = masonryChildren => {
    if (!masonryRef.current || !masonryChildren || masonryChildren.length === 0) {
      return;
    }

    const masonry = masonryRef.current;
    const masonryFirstChild = masonryRef.current.firstChild;
    const parentWidth = masonry.clientWidth;
    const firstChildWidth = masonryFirstChild.clientWidth;

    if (parentWidth === 0 || firstChildWidth === 0) {
      return;
    }

    const firstChildComputedStyle = window.getComputedStyle(masonryFirstChild);
    const firstChildMarginLeft = parseToNumber(firstChildComputedStyle.marginLeft);
    const firstChildMarginRight = parseToNumber(firstChildComputedStyle.marginRight);
    const currentNumberOfColumns = Math.round(parentWidth / (firstChildWidth + firstChildMarginLeft + firstChildMarginRight));
    const columnHeights = new Array(currentNumberOfColumns).fill(0);
    let skip = false;
    masonry.childNodes.forEach(child => {
      if (child.nodeType !== Node.ELEMENT_NODE || child.dataset.class === 'line-break' || skip) {
        return;
      }

      const childComputedStyle = window.getComputedStyle(child);
      const childMarginTop = parseToNumber(childComputedStyle.marginTop);
      const childMarginBottom = parseToNumber(childComputedStyle.marginBottom); // if any one of children isn't rendered yet, masonry's height shouldn't be computed yet

      const childHeight = parseToNumber(childComputedStyle.height) ? Math.ceil(parseToNumber(childComputedStyle.height)) + childMarginTop + childMarginBottom : 0;

      if (childHeight === 0) {
        skip = true;
        return;
      } // if there is a nested image that isn't rendered yet, masonry's height shouldn't be computed yet


      for (let i = 0; i < child.childNodes.length; i += 1) {
        const nestedChild = child.childNodes[i];

        if (nestedChild.tagName === 'IMG' && nestedChild.clientHeight === 0) {
          skip = true;
          break;
        }
      }

      if (!skip) {
        // find the current shortest column (where the current item will be placed)
        const currentMinColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
        columnHeights[currentMinColumnIndex] += childHeight;
        const order = currentMinColumnIndex + 1;
        child.style.order = order;
      }
    });

    if (!skip) {
      setMaxColumnHeight(Math.max(...columnHeights));
      const numOfLineBreaks = currentNumberOfColumns > 0 ? currentNumberOfColumns - 1 : 0;
      setNumberOfLineBreaks(numOfLineBreaks);
    }
  };

  const observer = react.useRef(typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(handleResize));
  react.useEffect(() => {
    const resizeObserver = observer.current; // IE and old browsers are not supported

    if (resizeObserver === undefined) {
      return undefined;
    }

    if (masonryRef.current) {
      masonryRef.current.childNodes.forEach(childNode => {
        resizeObserver.observe(childNode);
      });
    }

    return () => resizeObserver ? resizeObserver.disconnect() : {};
  }, [columns, spacing, children]);
  const handleRef = (0,useForkRef/* default */.Z)(ref, masonryRef); //  columns are likely to have different heights and hence can start to merge;
  //  a line break at the end of each column prevents columns from merging

  const lineBreaks = new Array(numberOfLineBreaks).fill('').map((_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    "data-class": "line-break",
    style: (0,esm_extends/* default */.Z)({}, lineBreakStyle, {
      order: index + 1
    })
  }, index));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MasonryRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: handleRef,
    ownerState: ownerState
  }, other, {
    children: [children, lineBreaks]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Masonry_Masonry = (Masonry);

/***/ }),

/***/ 6932:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1840);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ AUTHOR_CHIP_FRAGMENT; },
/* harmony export */   "Z": function() { return /* binding */ AuthorChip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8224);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9813);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9203);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4918);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3236);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AuthorChip on Author {\n    name\n    slug\n    picture {\n      url(\n        transformation: {\n          image: { resize: { fit: crop, width: 100, height: 100 } }\n        }\n      )\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AUTHOR_CHIP_FRAGMENT = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_templateObject());
function AuthorChip(param) {
    var author = param.author;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/author/".concat(author.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            avatar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                alt: author.name,
                src: (ref = author.picture) === null || ref === void 0 ? void 0 : ref.url
            }),
            clickable: true,
            label: author.name
        })
    });
};


/***/ }),

/***/ 4358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5303);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3236);



function Container(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: children
    });
};


/***/ }),

/***/ 8471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2645);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4918);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3236);




function Header() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            variant: "h1",
            children: "Yet another SWE Blog."
        })
    });
};


/***/ }),

/***/ 1792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2086);
// EXTERNAL MODULE: ./components/container.tsx
var container = __webpack_require__(4358);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(2645);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(218);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/link.js
var next_link = __webpack_require__(4918);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(3236);
;// CONCATENATED MODULE: ./components/footer.tsx





function Footer() {
    var link = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "https://github.com/Neitsch/neitsch.github.io",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            underline: "always",
            children: "here"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "Built with NextJS. Find the source ",
                    link,
                    "."
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/head.js
var head = __webpack_require__(2726);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/router.js
var next_router = __webpack_require__(2455);
;// CONCATENATED MODULE: ./components/meta.tsx





var site = "https://www.nigel-schuster.de";
function Meta() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            window.goatcounter.count({
                path: url
            });
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router.events
    ]);
    var canonicalURL = site + (0,next_router.useRouter)().asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: canonicalURL,
                rel: "canonical"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/apple-touch-icon.png",
                sizes: "180x180"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/favicon-32x32.png",
                rel: "icon",
                sizes: "32x32",
                type: "image/png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/favicon-16x16.png",
                rel: "icon",
                sizes: "16x16",
                type: "image/png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/site.webmanifest",
                rel: "manifest"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                color: "#000000",
                href: "/favicon/safari-pinned-tab.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/favicon.ico",
                rel: "icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "#000000",
                name: "msapplication-TileColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "/favicon/browserconfig.xml",
                name: "msapplication-config"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "#000",
                name: "theme-color"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/feed.xml",
                rel: "alternate",
                type: "application/rss+xml"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "Personal blog.",
                name: "description"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                "data-goatcounter": "https://nigel.goatcounter.com/count",
                "data-goatcounter-settings": "{}",
                src: "//gc.zgo.at/count.js"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layout.tsx




function Layout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ MORE_STORIES; },
/* harmony export */   "Z": function() { return /* binding */ MoreStories; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _components_post_preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(218);
/* harmony import */ var _mui_lab_Masonry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6380);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9203);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3236);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  fragment MoreStories on Query {\n    moreStories: posts(\n      orderBy: date_DESC\n      first: 2\n      where: { slug_not_in: [$slug] }\n    ) {\n      ...PostPreview\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var MORE_STORIES = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_templateObject(), _components_post_preview__WEBPACK_IMPORTED_MODULE_1__/* .POST_PREVIEW_FRAGMENT */ .H);
function MoreStories(param) {
    var moreStories = param.moreStories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "h4",
                children: "More Stories"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab_Masonry__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                columns: {
                    xs: 1,
                    sm: 2
                },
                spacing: {
                    xs: 1,
                    sm: 1,
                    md: 2
                },
                children: moreStories.map(function(post) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_post_preview__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            post: post
                        })
                    }, post.slug);
                })
            })
        ]
    });
};


/***/ }),

/***/ 4926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ POST_PREVIEW_FRAGMENT; },
/* harmony export */   "Z": function() { return /* binding */ PostPreview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _author_chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(970);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7563);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(218);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2299);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6696);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2754);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8062);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9203);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4918);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3236);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  fragment PostPreview on Post {\n    title\n    slug\n    excerpt\n    coverImage {\n      url(\n        transformation: {\n          image: { resize: { fit: crop, width: 2000, height: 1000 } }\n        }\n      )\n    }\n    author {\n      ...AuthorChip\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var POST_PREVIEW_FRAGMENT = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject(), _author_chip__WEBPACK_IMPORTED_MODULE_1__/* .AUTHOR_CHIP_FRAGMENT */ .R);
function PostPreview(param) {
    var _post = param.post, title = _post.title, coverImage = _post.coverImage, excerpt = _post.excerpt, author = _post.author, slug = _post.slug;
    var titleElem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        flexGrow: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            variant: "h4",
            children: title
        })
    });
    var previewHeader = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        display: "flex",
        children: [
            titleElem,
            author ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                alignSelf: "flex-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_author_chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    author: author
                })
            }) : null
        ]
    });
    var excerptElem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        variant: "body1",
        children: excerpt
    });
    var innerCardContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            previewHeader,
            excerptElem
        ]
    });
    var cardContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/posts/".concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: innerCardContent
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                component: "img",
                src: coverImage === null || coverImage === void 0 ? void 0 : coverImage.url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: cardContent
                })
            })
        ]
    });
};


/***/ }),

/***/ 1840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "INDEX_LOOKUP": function() { return /* binding */ INDEX_LOOKUP; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ index; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2086);
// EXTERNAL MODULE: ./components/container.tsx
var container = __webpack_require__(4358);
// EXTERNAL MODULE: ./components/author-chip.tsx
var author_chip = __webpack_require__(970);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(7563);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Card/Card.js + 3 modules
var Card = __webpack_require__(2299);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(6696);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(2754);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/CardActionArea/CardActionArea.js + 1 modules
var CardActionArea = __webpack_require__(8062);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(2645);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 19 modules
var lib = __webpack_require__(9203);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/link.js
var next_link = __webpack_require__(4918);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(3236);
;// CONCATENATED MODULE: ./components/hero-post.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  fragment HeroPost on Post {\n    title\n    slug\n    excerpt\n    coverImage {\n      url(\n        transformation: {\n          image: { resize: { fit: crop, width: 2000, height: 1000 } }\n        }\n      )\n    }\n    author {\n      ...AuthorChip\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var HERO_POST_FRAGMENT = (0,lib/* default */.ZP)(_templateObject(), author_chip/* AUTHOR_CHIP_FRAGMENT */.R);
function HeroPost(param) {
    var _post = param.post, title = _post.title, coverImage = _post.coverImage, author = _post.author, slug = _post.slug, excerpt = _post.excerpt;
    var titleElem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        flexGrow: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "h4",
            children: title
        })
    });
    var headerElem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        children: [
            titleElem,
            author ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                alignSelf: "flex-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(author_chip/* default */.Z, {
                    author: author
                })
            }) : null
        ]
    });
    var excerptElem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "body1",
        children: excerpt
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                component: "img",
                src: coverImage === null || coverImage === void 0 ? void 0 : coverImage.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/posts/".concat(slug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            children: [
                                headerElem,
                                excerptElem
                            ]
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/header.tsx
var header = __webpack_require__(8471);
;// CONCATENATED MODULE: ./components/intro.tsx




function Intro() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            flexGrow: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {})
        })
    });
};

// EXTERNAL MODULE: ./components/layout.tsx + 2 modules
var layout = __webpack_require__(1792);
// EXTERNAL MODULE: ./components/more-stories.tsx
var more_stories = __webpack_require__(768);
// EXTERNAL MODULE: ./components/post-preview.tsx
var post_preview = __webpack_require__(4926);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/head.js
var head = __webpack_require__(2726);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function pages_templateObject() {
    var data = pages_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n\n  query IndexLookup {\n    posts(orderBy: date_DESC, first: 20) {\n      ...PostPreview\n      ...HeroPost\n    }\n  }\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var __N_SSG = true;
var INDEX_LOOKUP = (0,lib/* default */.ZP)(pages_templateObject(), post_preview/* POST_PREVIEW_FRAGMENT */.H, HERO_POST_FRAGMENT);
function index(lookup) {
    var posts = lookup.posts;
    var morePosts = _toConsumableArray(posts);
    var heroPost = morePosts.shift();
    var heroPostElem = heroPost ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroPost, {
        post: heroPost
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Nigel Schuster's blog"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {}),
                    heroPostElem,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(more_stories/* default */.Z, {
                        moreStories: morePosts
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [503,774,888,179], function() { return __webpack_exec__(6932); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);